var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import InputUploader from "../common/components/InputUploader.vue";
import CompanyService from "../api/CompanyService";
import CommonService from "../api/CommonService";
import { Watch } from 'vue-property-decorator';
import GlobalVue from '../globalVue';
import RegexStr from "../common/RegexStr";
var phoneRegex = new RegExp(RegexStr.phone);
import _ from 'lodash';
var licenseInit = {
    document_code: '',
    document_pic: []
};
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.phoneRegex = phoneRegex;
        _this.model = {
            photos: []
        };
        _this.isEdit = false;
        _this.activeNames = ["1", "2", "3", "4", "5", "6", "7"];
        _this.applyAuthDisabled = false;
        _this.caseNames = ["一", "二", "三", "四", "五"];
        _this.companyModel = {
            business_license: __assign({}, licenseInit),
            openaccount_license: __assign({}, licenseInit),
            production_license: __assign({}, licenseInit),
            business_permit: __assign({}, licenseInit),
            other_license: [],
            factory_condition: [],
            equipment_condition: [],
            emergency_contacts: {},
            contacts: {},
            main_manager: {},
            company_name: "",
            employee_amount: "",
            average_turnover: "",
            average_net_profit: "",
            cover_area: "",
            ownership: "",
            company_bank_num: "",
            company_bank: "",
            business_scope: "",
            company_address: "",
            year_sales_money: "",
            quality_manager_amount: "",
            iso_desc: "",
            registered_capital_money: "",
            website_url: "",
            is_export: "",
            custom_processing_range: "",
            year_output: "",
            custom_processing_min_amount: 0,
            product_goods: "",
            cooperation_customer: "",
            company_phone: "",
            settlement: [],
            supplier_license_code: "",
            id_card: "",
        };
        _this.infoFlow = {
            base_info: "0%",
            management_info: "0%",
            finance_info: "0%",
            production_info: "0%",
            image_info: "0%",
            case_info: "0%",
            contact_info: "0%",
        };
        _this.infoFlowCurrIndex = -1;
        _this.supplierCooperationCase = [];
        _this.areaList = [];
        _this.exportCountryList = [];
        _this.serviceCityList = [];
        _this.typeList = [];
        _this.categoryList = [];
        _this.billtypeList = [];
        _this.settlementList = [];
        return _this;
    }
    default_1.prototype.created = function () {
        this.commonService = CommonService.getInstance();
        this.companyService = CompanyService.getInstance();
    };
    default_1.prototype.normalizer = function (id, name) {
        if (id === void 0) { id = "id"; }
        if (name === void 0) { name = "name"; }
        return function (node) { return ({
            id: node[id],
            label: node[name],
            children: node.children,
        }); };
    };
    default_1.prototype.mounted = function () {
        var _this = this;
        this.companyService.getDetail().then(function (res) {
            var data = res.data.data;
            data.goods_type_id = !data.goods_type_id ? [] : data.goods_type_id.split(",");
            data.goods_type_id = data.goods_type_id.map(function (item) { return Number(item); });
            data.provide_city_id = !data.provide_city_id ? [86000000] : data.provide_city_id.split(",");
            data.provide_city_id = data.provide_city_id.map(function (item) { return Number(item); });
            data.main_manager = data.main_manager ? data.main_manager : {};
            data.contacts = data.contacts ? data.contacts : {};
            data.emergency_contacts = data.emergency_contacts ? data.emergency_contacts : {};
            data.settlement = data.settlement.split(',').filter(function (v) { return v !== ''; }).map(function (item) { return (Number(item)); });
            data.is_apply_auth = data.is_apply_auth == 1;
            if (data.is_apply_auth) {
                _this.applyAuthDisabled = true;
            }
            ;
            if (data.supplier_cooperation_case.length > 0) {
                data.supplier_cooperation_case.forEach(function (row, rIndex) {
                    GlobalVue.$set(_this.supplierCooperationCase, rIndex, row);
                });
                _this.$nextTick(function () {
                    _this.supplierCooperationCase.forEach(function (item, idx) {
                        GlobalVue.$set(_this.supplierCooperationCase[idx], 'cooperation_ticket', JSON.parse(JSON.stringify(item.cooperation_ticket)));
                    });
                });
            }
            _this.commonService.getArea().then(function (res) {
                var area = [res.data.data[0]];
                _this.areaList = area[0].children.map(function (province) {
                    if (province.children) {
                        return __assign({}, province, { isDisabled: true, children: province.children.map(function (city) { return (__assign({}, city, { isDisabled: false })); }) });
                    }
                    else {
                        return __assign({}, province, { isDisabled: false });
                    }
                });
                _this.serviceCityList = area;
                _this.exportCountryList = res.data.data[1].children;
                if (data.isexport === 0) {
                    data.is_export = _this.exportCountryList.length ? _this.exportCountryList[0].id : '';
                }
                ;
                data.custom_processing_min_amount = (!data.custom_processing_min_amount || isNaN(data.custom_processing_min_amount)) ? 0 : data.custom_processing_min_amount;
                data.region_id = data.region_id == 0 ? null : data.region_id;
                _this.companyModel = Object.assign({}, _this.companyModel, data);
                _this.oldCompanyModel = _.cloneDeep(_this.companyModel);
            }).catch(function (err) {
                _this.$message.error(err.message || err.msg);
            });
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
        this.commonService.getOperateCategory({
            level: 3
        }).then(function (res) {
            _this.categoryList = res.data.data;
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
        this.companyService.getTaxinvoicetype().then(function (res) {
            _this.billtypeList = res.data.data;
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
        this.companyService.getCompanyTypeList().then(function (res) {
            _this.typeList = res.data.data;
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
        this.companyService.getSettlementList().then(function (res) {
            _this.settlementList = res.data.data;
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.watchCompany = function (val, oldVal) {
        var baseInfoNum = 0;
        if (val["company_name"].trim().length > 0) {
            baseInfoNum += 1;
        }
        if (val["region_id"] && val["region_id"] > 0) {
            baseInfoNum += 1;
        }
        if (val["found_date"] != null) {
            baseInfoNum += 1;
        }
        if (val["cover_area"].toString().trim().length > 0) {
            baseInfoNum += 1;
        }
        if (val["company_type_id"] > 0) {
            baseInfoNum += 1;
        }
        if (val["company_address"].trim().length > 0) {
            baseInfoNum += 1;
        }
        if (val["website_url"].trim().length > 0) {
            baseInfoNum += 1;
        }
        if (val["company_phone"].trim().length > 0) {
            baseInfoNum += 1;
        }
        this.infoFlow.base_info = Math.round((baseInfoNum / 8) * 100) + '%';
        var managementInfoNum = 0;
        if (val["goods_type_id"].length > 0) {
            managementInfoNum += 1;
        }
        if (val["business_scope"].length > 0) {
            managementInfoNum += 1;
        }
        if (val["employee_amount"].toString().trim().length > 0) {
            managementInfoNum += 1;
        }
        if (val["average_turnover"].toString().trim().length > 0) {
            managementInfoNum += 1;
        }
        if (val["is_export"] == 0) {
            managementInfoNum += 1;
        }
        else {
            managementInfoNum += 1;
        }
        if (val["provide_city_id"].length > 0) {
            managementInfoNum += 1;
        }
        if (val["year_sales_money"].toString().trim().length > 0) {
            managementInfoNum += 1;
        }
        if (val["quality_manager_amount"].toString().trim().length > 0) {
            managementInfoNum += 1;
        }
        if (val["average_net_profit"].toString().trim().length > 0) {
            managementInfoNum += 1;
        }
        this.infoFlow.management_info = Math.round((managementInfoNum / 9) * 100) + '%';
        var financeInfoNum = 1;
        if (val["company_bank"].trim().length > 0) {
            financeInfoNum += 1;
        }
        if (val["registered_capital_money"].toString().trim().length > 0) {
            financeInfoNum += 1;
        }
        if (val["settlement"].length > 0) {
            financeInfoNum += 1;
        }
        if (val["company_bank_num"].trim().length > 0) {
            financeInfoNum += 1;
        }
        this.infoFlow.finance_info = Math.round((financeInfoNum / 5) * 100) + '%';
        var productionInfoNum = 0;
        var productionInfoNumDivisor = 1;
        if (val["is_custom"] == 0) {
            productionInfoNum += 1;
        }
        else {
            productionInfoNum += 1;
            productionInfoNumDivisor = 2;
            if (val["custom_processing_min_amount"].toString().trim().length > 0) {
                productionInfoNum += 1;
            }
        }
        this.infoFlow.production_info = Math.round((productionInfoNum / productionInfoNumDivisor) * 100) + '%';
        var imageInfoNum = 0;
        if (val["business_license"].document_pic.length > 0) {
            imageInfoNum += 1;
        }
        if (val["production_license"].document_pic.length > 0) {
            imageInfoNum += 1;
        }
        if (val["business_permit"].document_pic.length > 0) {
            imageInfoNum += 1;
        }
        if (val["openaccount_license"].document_pic.length > 0) {
            imageInfoNum += 1;
        }
        if (val["other_license"].length > 0) {
            imageInfoNum += 1;
        }
        if (val["factory_condition"].length > 0) {
            imageInfoNum += 1;
        }
        if (val["equipment_condition"].length > 0) {
            imageInfoNum += 1;
        }
        this.infoFlow.image_info = Math.round((imageInfoNum / 6) * 100) + '%';
        var contactInfoNum = 0;
        if (val["main_manager"].name && val["main_manager"].name.trim().length > 0) {
            contactInfoNum += 1;
        }
        if (val["main_manager"].title && val["main_manager"].title.trim().length > 0) {
            contactInfoNum += 1;
        }
        if (val["main_manager"].phone && val["main_manager"].phone.trim().length > 0) {
            contactInfoNum += 1;
        }
        if (val["main_manager"].email && val["main_manager"].email.trim().length > 0) {
            contactInfoNum += 1;
        }
        if (val["contacts"].name && val["contacts"].name.trim().length > 0) {
            contactInfoNum += 1;
        }
        if (val["contacts"].title && val["contacts"].title.trim().length > 0) {
            contactInfoNum += 1;
        }
        if (val["contacts"].phone && val["contacts"].phone.trim().length > 0) {
            contactInfoNum += 1;
        }
        if (val["contacts"].email && val["contacts"].email.trim().length > 0) {
            contactInfoNum += 1;
        }
        if (val["emergency_contacts"].name && val["emergency_contacts"].name.trim().length > 0) {
            contactInfoNum += 1;
        }
        if (val["emergency_contacts"].title && val["emergency_contacts"].title.trim().length > 0) {
            contactInfoNum += 1;
        }
        if (val["emergency_contacts"].phone && val["emergency_contacts"].phone.trim().length > 0) {
            contactInfoNum += 1;
        }
        if (val["emergency_contacts"].email && val["emergency_contacts"].email.trim().length > 0) {
            contactInfoNum += 1;
        }
        this.infoFlow.contact_info = Math.round((contactInfoNum / 12) * 100) + '%';
        this.changeInfoFlowCurrIndex(val, this.oldCompanyModel);
        this.oldCompanyModel = _.cloneDeep(val);
    };
    default_1.prototype.watchCase = function (val, oldVal) {
        var caseInfoNum = 0;
        if (val.length > 0) {
            val.map(function (caseinfo) {
                var caseLen = 0;
                if (caseinfo.case_business_name.trim().length > 0) {
                    caseLen += 1;
                }
                if (caseinfo.case_desc.trim().length > 0) {
                    caseLen += 1;
                }
                if (caseinfo.cooperation_month.toString().trim().length > 0) {
                    caseLen += 1;
                }
                if (caseinfo.cooperation_ticket.filter(function (v) { return v.url; }).length > 0) {
                    caseLen += 1;
                }
                if (caseLen > caseInfoNum) {
                    caseInfoNum = caseLen;
                    caseLen = 0;
                }
            });
        }
        this.infoFlow.case_info = Math.round((caseInfoNum / 4) * 100) + '%';
        this.infoFlowCurrIndex = 5;
    };
    default_1.prototype.dropVisibleChange = function (value) {
        try {
            if (value) {
                document.getElementsByTagName('body')[0].classList.add('company-container');
            }
            else {
                document.getElementsByTagName('body')[0].classList.remove('company-container');
            }
        }
        catch (error) { }
    };
    default_1.prototype.changeInfoFlowCurrIndex = function (newVal, oldVal) {
        var reduceFn = function (total, key) {
            if (typeof newVal[key] == 'object') {
                if (JSON.stringify(newVal[key]) != JSON.stringify(oldVal[key])) {
                    console.log(key);
                    total++;
                }
            }
            else {
                if (newVal[key] != oldVal[key]) {
                    console.log(key);
                    total++;
                }
            }
            return total;
        };
        var baseInfoChangeNum = [
            "company_name",
            "region_id",
            "found_date",
            "cover_area",
            "company_type_id",
            "company_address",
            "website_url",
            "company_phone",
        ].reduce(reduceFn, 0);
        if (baseInfoChangeNum > 0) {
            this.infoFlowCurrIndex = 0;
            return;
        }
        var managementInfoChangeNum = [
            "goods_type_id",
            "business_scope",
            "employee_amount",
            "average_turnover",
            "is_export",
            "provide_city_id",
            "year_sales_money",
            "quality_manager_amount",
            "average_net_profit",
        ].reduce(reduceFn, 0);
        if (managementInfoChangeNum > 0) {
            this.infoFlowCurrIndex = 1;
            return;
        }
        var financeInfoChangeNum = [
            "company_bank",
            "registered_capital_money",
            "settlement",
            "company_bank_num"
        ].reduce(reduceFn, 0);
        if (financeInfoChangeNum > 0) {
            this.infoFlowCurrIndex = 2;
            return;
        }
        var productionInfoChangeNum = [
            "is_custom",
            "custom_processing_min_amount"
        ].reduce(reduceFn, 0);
        if (productionInfoChangeNum > 0) {
            this.infoFlowCurrIndex = 3;
            return;
        }
        var imageInfoChangeNum = [
            "business_license",
            "production_license",
            "business_permit",
            "openaccount_license",
            "other_license",
            "factory_condition",
            "equipment_condition",
        ].reduce(reduceFn, 0);
        if (imageInfoChangeNum > 0) {
            this.infoFlowCurrIndex = 4;
            return;
        }
        this.infoFlowCurrIndex = 6;
    };
    default_1.prototype.getEmptyLabels = function () {
        var _this = this;
        var requiredNameArr = [
            { name: 'company_name', label: '企业名称' },
            { name: 'company_type_id', label: '企业类型' },
            { name: 'goods_type_id', label: '经营品类' },
            { name: 'region_id', label: '所在区域' },
            { name: 'provide_city_id', label: '服务城市' },
            { name: 'tax_ticket_type_id', label: '开票类型' },
            { name: 'settlement', label: '结账方式' }
        ];
        var emptyNameArr = [];
        requiredNameArr.forEach(function (item) {
            if (Array.isArray(_this.companyModel[item.name]) && !_this.companyModel[item.name].length) {
                emptyNameArr.push(item.label);
            }
            if (!_this.companyModel[item.name]) {
                emptyNameArr.push(item.label);
            }
        });
        return emptyNameArr.join('、');
    };
    default_1.prototype.save = function () {
        var _this = this;
        var reg = /^((0\d{2,3}-\d{7,8})|(1\d{10}))$/;
        this.$validator.validateScopes().then(function (res) {
            if (!res) {
                _this.$message.error("请填写所有必填字段，并且按字段格式要求填写");
                return;
            }
            var data = JSON.parse(JSON.stringify(_this.companyModel));
            ["business_license",
                "openaccount_license",
                "production_license",
                "business_permit",].forEach(function (item) {
                if (data[item] && data[item].document_pic.length) {
                    data[item].document_pic = data[item].document_pic.map(function (model) { return ({ url: model.url, text: model.text || "" }); });
                }
            });
            ["other_license",
                "factory_condition",
                "equipment_condition"].forEach(function (item) {
                if (data[item] && data[item].length) {
                    data[item] = data[item].map(function (model) { return ({ url: model.url, text: model.text || "" }); });
                }
            });
            if (_this.supplierCooperationCase && _this.supplierCooperationCase.length > 0) {
                _this.supplierCooperationCase.forEach(function (cooperation_case) {
                    cooperation_case.cooperation_ticket = cooperation_case.cooperation_ticket.map(function (model) { return ({ url: model.url, text: model.text || "" }); });
                });
            }
            data.is_apply_auth = data.is_apply_auth ? 1 : 0;
            data.settlement = data.settlement.join(',');
            data.supplier_cooperation_case = _this.supplierCooperationCase;
            _this.companyService.save({ data: JSON.stringify(data) }).then(function (res) {
                if (res.data.success) {
                    _this.$message.success(res.data.msg || "保存成功");
                    if (data.is_apply_auth == 1) {
                        _this.applyAuthDisabled = true;
                    }
                }
                else {
                    _this.$message.error(res.data.msg || "保存失败");
                }
            }, function (err) {
                _this.$message.error(err.msg || "保存失败");
            });
        });
    };
    default_1.prototype.addCase = function () {
        var obj = {
            case_business_name: "",
            case_desc: "",
            cooperation_month: "",
            cooperation_ticket: []
        };
        if (this.supplierCooperationCase.length >= 5) {
            this.$message.error("合作案例最多五个");
            return;
        }
        this.supplierCooperationCase = this.supplierCooperationCase.concat([obj]);
    };
    default_1.prototype.delCase = function (item, index) {
        var _this = this;
        this.$confirm("\u5220\u9664\u540E\u4E0D\u53EF\u6062\u590D\uFF0C\u8BF7\u8C28\u614E\u786E\u8BA4", '提示', {
            customClass: 'confirm',
            confirmButtonText: '确定',
            center: true,
        }).then(function (res) {
            if (res) {
                _this.supplierCooperationCase = _this.supplierCooperationCase.filter(function (v, vIndex) { return vIndex != index; });
            }
        }).catch(function () { });
    };
    default_1.prototype.slideCollapseItem = function (index) {
        var slideDom = function () {
            $('#company-collapse-list .el-collapse-item')[index].scrollIntoView();
            if (index != 6) {
                $('.tab-content')[0].scrollTop = $('.tab-content')[0].scrollTop - 161;
            }
        };
        var colName = index + 1 + '';
        if (this.activeNames.indexOf(colName) == -1) {
            this.activeNames = this.activeNames.concat([colName]);
            this.$nextTick(function () {
                slideDom();
            });
        }
        else {
            slideDom();
        }
        this.infoFlowCurrIndex = index;
    };
    __decorate([
        Watch("companyModel", { deep: true })
    ], default_1.prototype, "watchCompany", null);
    __decorate([
        Watch("supplierCooperationCase", { deep: true })
    ], default_1.prototype, "watchCase", null);
    default_1 = __decorate([
        Component({
            components: {
                InputUploader: InputUploader
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
